import { render, staticRenderFns } from "./AscMxRecAttachmentsWrapper.vue?vue&type=template&id=b0a0c900&"
import script from "./AscMxRecAttachmentsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecAttachmentsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecAttachmentsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports